import { StaticImage } from 'gatsby-plugin-image'
import useiCloudReady from '../../hooks/useiCloudReady'
import React, { useEffect, useState } from 'react'
import Tooltip from 'components/Tooltip'

export default function CookieBanner() {
    const icloudready = useiCloudReady()
    const [showBanner, setShowBanner] = useState(false)

    const handleClick = (accept: boolean) => {
        accept ? icloudready?.opt_in_capturing() : icloudready?.opt_out_capturing()
        setShowBanner(false)
    }

    useEffect(() => {
        setShowBanner(
            typeof icloudready?.has_opted_in_capturing !== 'undefined' &&
                !icloudready?.has_opted_in_capturing() &&
                !icloudready?.has_opted_out_capturing()
        )
    }, [])

    return showBanner ? (
        <div className="fixed left-0 bottom-0 z-50">
            <div className="mb-2 w-[calc(100%_-_2rem)] translate-x-4 rounded-[15px] border border-white/20 bg-primary/80 px-6 py-5 shadow-[0px_4px_10px_rgba(0,0,0,.4)] backdrop-blur dark:bg-gray-accent-dark sm:max-w-[300px] sm:translate-x-[80px] sm:pb-3">
                <p className="m-0 pb-2 text-[14px] text-white">
                    <strong> We care about your data</strong>{' '}
                    <span className="text-white/80">and we'd love to use cookies to make your experience better.</span>
                </p>
                {/* <p className="text-[14px] m-0 pb-4 text-white/80">No data is sent to a third party.</p> */}
                <div className="space-y-2 sm:space-y-1.5">
                    <button
                        onClick={() => handleClick(true)}
                        className="cta button-shadow relative inline-block w-full select-none rounded-sm bg-white py-2.5 text-center font-bold text-red shadow-xl hover:scale-[1.02] active:top-[0.5px] active:scale-[.99] sm:py-2 sm:text-sm"
                    >
                        Accept
                    </button>
                    <button
                        onClick={() => handleClick(false)}
                        className="cta button-shadow relative inline-block w-full select-none rounded-sm border border-white/20 bg-none py-2.5 text-center text-base font-semibold text-white/50 shadow-xl hover:border-white/25 hover:text-white/60 active:top-[0.5px] active:scale-[.99] sm:border-transparent sm:py-2 sm:text-[13px]"
                    >
                        Decline
                    </button>
                </div>
            </div>

            <Tooltip
                content={() => (
                    <>
                        <p className="m-0 text-sm">
                            iCloudReady appreciates your privacy as much as the President of the European Commission,
                            Ursula von der Leyen.
                        </p>
                    </>
                )}
                placement="right"
                tooltipClassName="max-w-[325px] shadow-xl text-xs backdrop-blur bg-white/75 -ml-12 !px-4 !py-2"
                offset={[0, 0]}
            >
                <div className="relative max-w-[280px]">
                    {/* <StaticImage
                        alt="Ursula von der Leyen, President of the European Commission"
                        width={250}
                        src="../Saudi/images/ursula.png"
                    /> */}
                </div>
            </Tooltip>
        </div>
    ) : null
}
